import requests from "./httpService";

const HandbookService = {
  getMy() {
    return requests.get("/handbook/my");
  },
  upsertMy(body) {
    return requests.put("/handbook/my", body);
  },
  deleteMy() {
    return requests.delete("/handbook/my");
  },
  getParent() {
    return requests.get("/handbook/parent");
  },
  uploadPrincipalImage(file) {
    const fd = new FormData();
    fd.append("image", file);
    return requests.post("/handbook/my/principal-image", fd);
  },
};

export default HandbookService;

